import { Component, inject, OnInit } from '@angular/core';
import { InvoiceClaimContent } from './invoice-claim';
import { ActivatedRoute } from '@angular/router';
import { invoiceClaimJson } from '../../../@core/utils/invoice-claim.data';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-claim-voucher',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './invoice-claim-voucher.component.html',
  styleUrl: './invoice-claim-voucher.component.scss'
})
export class InvoiceClaimVoucherComponent implements OnInit {
  data!: InvoiceClaimContent;
  status:'success' | 'failed' = 'success';

  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
   this.status = this.route.snapshot.params['status'];
   this.data = invoiceClaimJson[this.status];
  }
}
